import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import AdminSidebar from '@/components/AdminSidebar';

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-50" data-testid="admin-layout">
      {/* Sidebar (desktop: inline; mobile: overlay via AdminSidebar) */}
      <AdminSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Main content */}
      <div className="flex-1 min-w-0 flex flex-col">
        {/* Mobile top bar with hamburger */}
        <div
          className="lg:hidden sticky top-0 z-30 bg-[#0B1E44] px-4 py-3 flex items-center gap-3 shadow-md"
          data-testid="admin-mobile-topbar"
        >
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-white/90 hover:text-white px-2 py-1 -ml-1 rounded-md border border-white/20 inline-flex items-center gap-1.5 text-sm font-semibold"
            aria-label="Abrir menu do painel"
            data-testid="admin-hamburger-btn"
          >
            <Menu className="h-5 w-5" />Menu do painel
          </button>
          <span
            className="font-semibold text-white text-sm"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            trabadju · Admin
          </span>
        </div>

        {/* Page content */}
        <Outlet />
      </div>
    </div>
  );
}
